import axios from 'axios';
import {
  ContentCarousel as Carousel, SkeletonLoader, Slide
} from 'member-web-shared-components';
import React from 'react';
import { ContentCarouselProps } from '../../types/App';
import './ContentCarousel.scss';

const ContentCarousel = (props: ContentCarouselProps) => {
  const {
    componentId,
    title,
    endPoint
  } = props;

  const { useState, useEffect } = React;

  const [state, setState] = useState({
    slides: [] as Slide[]
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(endPoint);
        setState({ slides: response.data });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    };

    fetchData();
  }, [endPoint]);

  const { slides } = state;

  return (
    <div
      data-testid={componentId}
      className='content-carousel'
    >
      <div className='content-carousel__wrapper'>
        {slides.length === 0 ? (
          <div className='content-carousel__skeleton-container'>
            <div className='content-carousel__skeleton-left'>
              <div className='content-carousel__skeleton-image'>
                <SkeletonLoader numberOfLines={1} testId='' />
              </div>
            </div>
            <div className='content-carousel__skeleton-right'>
              <div className='content-carousel__skeleton-title'>
                <SkeletonLoader numberOfLines={1} testId='' />
              </div>
              <div className='content-carousel__skeleton-description'>
                <SkeletonLoader numberOfLines={1} testId='' />
              </div>
              <div className='content-carousel__skeleton-nav'>
                <SkeletonLoader numberOfLines={1} testId='' />
                <SkeletonLoader numberOfLines={1} testId='' />
                <SkeletonLoader numberOfLines={1} testId='' />
              </div>
            </div>
          </div>
        ) : (
          <Carousel title={title} slides={slides} />
        )}
      </div>
    </div>
  );
};

export default ContentCarousel;
